import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import {
    DataContent,
    Image,
    OverSection,
    SectionDataTypography,
} from './styles'
import { ProfileSectionProps } from 'src/pages/DetailedBlogs/InformationSection/Types'
import {
    ContentData,
    ContentInformation,
    ContentName,
    ImageIcon,
    TypographyDate,
    TypographyHeader,
} from 'src/pages/DetailedBlogs/ProfileSection/styles'
import ImageTime from 'src/assets/Blog/ImageTime.avif'
import ImagePerson from 'src/assets/Blog/imageperson.avif'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'

export const DataInformation = ({ Blog }: ProfileSectionProps) => {
    const { i18n } = useTranslation()
    const uploadDate = Blog.date
        ? format(new Date(Blog.date), 'eeee dd, MMMM yyyy')
        : ''
    const uploadDateEs = Blog.date
        ? format(new Date(Blog.date), 'eeee dd, MMMM yyyy', { locale: es })
        : ''
    return (
        <OverSection>
            <ContentInformation>
                {i18n.language === 'es' ? (
                    <TypographyHeader
                        variant={'h1'}
                        fontSize={[
                            'initial',
                            'initial',
                            'xxxtitle',
                            'xxxlarge',
                        ]}
                        fontWeight={700}
                    >
                        {Blog.tittleContentEs}
                    </TypographyHeader>
                ) : (
                    <TypographyHeader
                        variant={'h1'}
                        fontSize={[
                            'initial',
                            'initial',
                            'xxxtitle',
                            'xxxlarge',
                        ]}
                        fontWeight={700}
                    >
                        {Blog.tittleContent}
                    </TypographyHeader>
                )}
                <ContentData marginTop={'xxmedium'} marginBottom={'xxlarge'}>
                    <ImageIcon src={ImageTime} alt={"Icon"}  />
                    {i18n.language === 'es' ? (
                        <TypographyDate
                            variant={'h3'}
                            fontSize={[
                                'xxsmall',
                                'xxsmall',
                                'medium',
                                'xxxsmall',
                            ]}
                            fontWeight={600}
                        >
                            {uploadDateEs}
                        </TypographyDate>
                    ) : (
                        <TypographyDate
                            variant={'h3'}
                            fontSize={[
                                'xxsmall',
                                'xxsmall',
                                'medium',
                                'xxxsmall',
                            ]}
                            fontWeight={600}
                        >
                            {uploadDate}
                        </TypographyDate>
                    )}
                    <ContentName marginLeft={'medium'}>
                        <ImageIcon src={ImagePerson} alt={"icon"}/>
                        <TypographyDate
                            variant={'h3'}
                            fontSize={[
                                'xxsmall',
                                'xxsmall',
                                'medium',
                                'xxxsmall',
                            ]}
                            fontWeight={600}
                        >
                            {Blog.authorName}
                        </TypographyDate>
                    </ContentName>
                </ContentData>
            </ContentInformation>
            <Image
                src={Blog.imageTwo.fields.file.url}
                alt={Blog.tittleContent}
            />
            {i18n.language === 'es' ? (
                <>
                    <DataContent marginTop={'xxmedium'}>
                        <SectionDataTypography
                            variant={'h2'}
                            fontSize={'medium'}
                            fontWeight={400}
                        >
                            {Blog.thumbnailEsp &&
                                documentToReactComponents(Blog.thumbnailEsp)}
                        </SectionDataTypography>
                    </DataContent>
                    <DataContent marginTop={'xxmedium'}>
                        <SectionDataTypography
                            variant={'h2'}
                            fontSize={'medium'}
                            fontWeight={400}
                        >
                            {Blog.thumbnailSecontEs &&
                                documentToReactComponents(
                                    Blog.thumbnailSecontEs
                                )}
                        </SectionDataTypography>
                    </DataContent>
                </>
            ) : (
                <>
                    <DataContent marginTop={'xxmedium'}>
                        <SectionDataTypography
                            variant={'h2'}
                            fontSize={'medium'}
                            fontWeight={400}
                        >
                            {Blog.thumbnailEng &&
                                documentToReactComponents(Blog.thumbnailEng)}
                        </SectionDataTypography>
                    </DataContent>
                    <DataContent marginTop={'xxmedium'}>
                        <SectionDataTypography
                            variant={'h2'}
                            fontSize={'medium'}
                            fontWeight={400}
                        >
                            {Blog.thumbnailSecEng &&
                                documentToReactComponents(Blog.thumbnailSecEng)}
                        </SectionDataTypography>
                    </DataContent>
                </>
            )}
        </OverSection>
    )
}
